<template>
  <div class="attachment-div">
    <!-- {{attachment.id}} -->
    <a v-if="isDocument" href="#" @click.prevent="downloadDocument">
      <img
        class="attachment-img-div"
        src="/img/attachments/pdf-icon.png"
        :alt="attachment.attachmentName || 'PDF'"
      />
    </a>
    <div v-else v-viewer="viewerOptions">
      <img
        class="attachment-img-div"
        :src="attachment.attachment"
        :key="attachment.id"
        :data-href="attachment.attachmentName"
        alt=" "
      />
    </div>
    <div class="mt-2 attachment-discard-div">
      <a v-if="discardVisible" href="#" @click.prevent="discard">
        <label class="link">
          {{ $t("geral.discard") }}
        </label>
      </a>
    </div>
    <div class="textAttachment" v-if="attachmentNumber != null">
      Anexo {{ attachmentNumber }}
    </div>

    <!-- {{attachments}} -->
  </div>
</template>

<script>
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";

Vue.use(Viewer);

export default {
  props: {
    attachment: Object,
    discardVisible: Boolean,
    fieldValue: Object,
    attachmentNumber: Number,
    attachments: Array
  },
  data() {
    return {
      viewerOptions: {
        movable: true,
        rotatable: false,
        scalable: false,
        navbar: false,
        title: false,
        fullscreen: false,
        rotatable: true,
        zoomable: true,
        toolbar: true
      }
    };
  },
  computed: {
    isDocument() {
      const attachmentName = this.attachment?.attachmentName || "";
      const attachmentContent = this.attachment?.attachment || "";

      return (
        attachmentName.toLowerCase().endsWith(".pdf") ||
        attachmentContent.startsWith("data:application/pdf")
      );
    }
  },
  methods: {
    downloadDocument() {
      if (!this.attachment?.attachment) return;

      const link = document.createElement("a");
      link.href = this.attachment.attachment;
      link.download = this.attachment.attachmentName || "anexo.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    discard() {
      this.$emit("update", this.attachments);
      this.$emit("discard", this.attachment);
    }
  }
};
</script>
<style scoped>
.attachment-div {
  border: 1px;
  border-color: #2b3553;
  border-radius: 0.4285rem;
  border-style: solid;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;
  margin-top: 10px;
  margin-bottom: 15px;
  text-align: center;
}
.attachment-discard-div {
  text-align: center;
}
.attachment-img-div {
  align-items: center !important;
  /* display: flex; */
  max-width: 100%;
  max-height: 100%;
  height: 240px;
}
.textAttachment {
  text-align: center !important;
}
.link {
  cursor: pointer;
}
.link:hover {
  color: white !important;
}
</style>
